export const config = {
  API_URL: process.env.NEXT_PUBLIC_API_URL || "http://localhost:9013/api/v1",
};
